import React from "react";
import { GH_COLORS } from "./Style";
import { ScheduleConfig } from "../types/schedule";

function formatHour(hour: number) {
  const suffix = hour >= 12 ? "오후" : "오전";
  const h12 = hour % 12 === 0 ? 12 : hour % 12;
  return `${suffix} ${h12}시`;
}

type TimeLineProps = {
  top: number;
  hour: number;
  config: ScheduleConfig;
};

const TimeLine: React.FC<TimeLineProps> = ({ top, hour, config }) => {
  const labelWidth = config.leftMarginPx - 5;
  return (
    <React.Fragment key={`timeLine-${hour}`}>
      {/* 시간 구분선: 라벨 텍스트 시작(left:0)부터 마지막 요일 구분선까지 */}
      <div
        style={{
          position: "absolute",
          top: `${top}px`,
          left: `${config.leftMarginPx}px`,
          width: `calc(100% - ${config.leftMarginPx}px - ${config.rightMarginPx}px)`,
          borderTop: `1px solid ${GH_COLORS.border}`,
        }}
      />
      {/* 시간 라벨 */}
      <div
        style={{
          position: "absolute",
          top: `${top - 6}px`,
          left: 0,
          width: `${labelWidth}px`,
          textAlign: "right",
          paddingRight: 12,
          fontSize: 12,
          fontWeight: 600,
          color: "#222",
        }}
      >
        {formatHour(hour)}
      </div>
    </React.Fragment>
  );
};

export default TimeLine;
